import { makeStyles } from '@mui/styles';

import { globalTheme as theme } from '@styles';

export const useStyles = makeStyles(() => ({
  container: {
    display: 'flex',
    flexDirection: 'column',
    gap: '1rem',
    color: '#28333e',
    fontWeight: 300,
    padding: '1rem 1.5rem 1.5rem',
  },
  title: {
    fontSize: '20px',
    fontWeight: 600,
    fontFamily: 'Poppins',
  },
  subHeader: {
    fontSize: '16px',
    fontFamily: 'Poppins',
  },
  list: {
    textAlign: 'left',
    fontSize: '16px',
    paddingLeft: '20px',
    margin: '0',
    fontFamily: 'Poppins',
  },
  disclaimer: {
    padding: '1rem',
    backgroundColor: '#f6f7f8',
  },
  disclaimerText: {
    fontFamily: 'Poppins',
    fontSize: '12px',
  },
  bold: {
    fontWeight: 600,
  },
  filled: {
    fontWeight: 500,
    fontFamily: 'Poppins, sans-serif',
    borderRadius: 4,
    backgroundColor: theme.palette.brandGreen.dark,

    '&:hover': {
      backgroundColor: theme.palette.brandGreen.dark,
    },

    '&:active': {
      backgroundColor: theme.palette.brandGreen.dark,
    },
  },
  outlined: {
    fontWeight: 500,
    fontFamily: 'Poppins, sans-serif',
    borderRadius: 4,
    backgroundColor: theme.palette.common.white,
    borderColor: theme.palette.brandGray.light,
    borderStyle: 'solid',
    borderWidth: '2px',
    color: theme.palette.brandGray.dark,
    boxShadow: 'none',

    '&:hover': {
      backgroundColor: theme.palette.action.hover,
      boxShadow: 'none',
    },

    '&:active': {
      backgroundColor: theme.palette.common.white,
    },
  },
  buttonContainer: {
    display: 'flex',
    flexDirection: 'column',
    gap: '0.5rem',
  },
}));
